import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
    name: "parseCalendarDate",
    standalone: false,
})
export class ParseCalendarDatePipe implements PipeTransform {
    transform(value: string) {
        return moment(value).format("DD MMM YYYY");
    }
}
